export default __webpack_public_path__ + "static/media/Background_00266.827b32c2.png";